export enum UploadStatus {
  NotStarted = 0,
  InProgress = 1,
  Success = 2,
  GeneralError = 3,
  FileSizeError = 4,
  FileTypeError = 5,
}

export enum CallStatus {
  Processing = 'Processing',
  Complete = 'Complete',
  Failed = 'Failed',
  Finalizing = 'Finalizing',
}

export enum ApiSummaryStatus {
  SummarizationSavedOnline = 'SUMMARIZATION_SAVED_ONLINE',
  SummarizationFailure = 'SUMMARIZATION_FAILURE',
  FlattenFailure = 'SUMMARIZATION_FLATTEN_FAILURE',
  SpeakerDiarizationComplete = 'SPEAKER_DIARIZATION_SUCCESS',
}

export enum UserRoleEnum {
  Sales = 'sales',
  Compliance = 'compliance',
  Servicing = 'servicing',
}

export enum FileType {
  Audio = 'audio',
  Pdf = 'pdf',
}

export enum ApiRunConfigStatus {
  Pending = 'PENDING',
  InProgress = 'INPROGRESS',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
}

export enum RunConfigStatus {
  Pending = 'Pending',
  InProgress = 'In Progress',
  Completed = 'Completed',
  Failed = 'Failed',
}

export enum PipelineType {
  Hmda = 'HMDA',
  Sales = 'SALES',
  Servicing = 'SERVICING',
  Idp = 'IDP',
  NotDefined = 'NOT_DEFINED',
  Copilot = 'COPILOT',
}

export enum PipelineNames { 
  SALES = 'sales_pipeline',
  HMDA = 'hmda',
  SERVICING = 'servicing',
  NOT_DEFINED = 'not_defined_pipeline',
  COPILOT = 'copilot_pipeline',
}

export enum FeedbackSentiment {
  Positive = 'POSITIVE',
  Negative = 'NEGATIVE',
}
